import * as angular from "angular";
import {IController} from "angular";
import {ShipperPortalModuleConfigurationType} from "../../types/shipper-portal-module-configuration.type";
import {
  SHIPPER_APP_CUSTOMER_CONFIGURATION,
  SHIPPER_APP_ORDER_CONFIGURATION, SHIPPER_APP_PAYMENT_CONFIGURATION,
  ShipperPortalConfiguration
} from "../../models/shipper-portal-configuration";
import {SettingsService} from "../../services/settings-service.service";

export class ShipperPortalConfigurationComponent implements IController {

  configuration: ShipperPortalConfiguration;
  public configurationCopy: any;
  public editModeModule: string;
  public shipperPortalModuleConfigurationType: typeof ShipperPortalModuleConfigurationType = ShipperPortalModuleConfigurationType;

  constructor(private settingsService: SettingsService) {
  }

  $onInit() {
    this.initConfigurationCopy(this.configuration);
  }

  onClickEditModule(shipperPortalModuleConfigurationType: ShipperPortalModuleConfigurationType) {
    this.editModeModule = shipperPortalModuleConfigurationType;
  }

  onCancelEdit() {
    this.editModeModule = undefined;
    this.initConfigurationCopy(this.configuration);
  }

  onChangeValue(value, path, field) {
    path[field] = value;
  }

  onEditModuleConfig(module) {
    if (module === this.shipperPortalModuleConfigurationType.order) {
      this.onEditOrderModuleConfiguration(this.configurationCopy[this.shipperPortalModuleConfigurationType.order]);
    } else if (module === this.shipperPortalModuleConfigurationType.customer) {
      this.onEditCustomerModuleConfiguration(this.configurationCopy[this.shipperPortalModuleConfigurationType.customer]);
    } else if (module === this.shipperPortalModuleConfigurationType.payment) {
      this.onEditPaymentModuleConfiguration(this.configurationCopy[this.shipperPortalModuleConfigurationType.payment]);
    }
  }

  private onEditOrderModuleConfiguration(orderConfiguration: SHIPPER_APP_ORDER_CONFIGURATION) {
    this.settingsService.updateOrderShipperAppConfig(orderConfiguration)
      .then((res) => {
        this.editModeModule = undefined;
        this.configuration[this.shipperPortalModuleConfigurationType.order] = res;
        this.initConfigurationCopy(this.configuration);
      });
  }

  private onEditCustomerModuleConfiguration(customerConfiguration: SHIPPER_APP_CUSTOMER_CONFIGURATION) {
    this.settingsService.updateCustomerShipperAppConfig(customerConfiguration)
      .then((res) => {
        this.editModeModule = undefined;
        this.configuration[this.shipperPortalModuleConfigurationType.customer] = res;
        this.initConfigurationCopy(this.configuration);
      });
  }

  private onEditPaymentModuleConfiguration(paymentConfiguration: SHIPPER_APP_PAYMENT_CONFIGURATION) {
    this.settingsService.updatePaymentShipperAppConfig(paymentConfiguration)
      .then((res) => {
        this.editModeModule = undefined;
        this.configuration[this.shipperPortalModuleConfigurationType.payment] = res;
        this.initConfigurationCopy(this.configuration);
      });
  }


  private initConfigurationCopy(configuration: ShipperPortalConfiguration) {
    this.configurationCopy = new ShipperPortalConfiguration(configuration);
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('shipperPortalConfigurationView', {
    bindings: {
      configuration: '<'
    },
    template: require('./shipper-portal-configuration.html').default,
    controller: ShipperPortalConfigurationComponent
  });
